// resources/js/utils/loadPrimeVue.js
let primevueLoaded = false

export async function loadPrimeVue(app) {
  if (primevueLoaded) return

  const PrimeVue = (await import('primevue/config')).default
  const Aura = (await import('@primeuix/themes/aura')).default

  app.use(PrimeVue, { 
    theme: { 
      preset: Aura
    } 
  })

  // Load PrimeIcons CSS dynamically
  await import('@/utils/primevueStyles.js')

  primevueLoaded = true
}

